import {Loader} from '@googlemaps/js-api-loader';
import GoogleMapTheme from "../../util/GoogleMapTheme";

export default {
	init() {
		setupMap();
	}
};

function setupMap() {
	let $wrapper = $('.job-single-map-section .inner-map'),
		loader = new Loader({
			apiKey: vibeTeamtailorFrontendTerritoryStudioScriptData.googleMapsApi,
			version: 'weekly'
		});

	loader.load().then(() => {
		loadMap($wrapper);
	});
}

function loadMap($mapElem) {
	let lat = $mapElem.data('latitude'),
		lng = $mapElem.data('longitude'),
		map = new google.maps.Map($mapElem.get(0), {
			center: {lat: lat, lng: lng},
			zoom: 11,
			scrollWheel: false,
			mapTypeControl: false,
			fullscreenControl: false,
			zoomControl: false,
			streetViewControl: false,
			scaleControl: false,
			styles: GoogleMapTheme(),
		}),
		marker = new google.maps.Marker({
			position: {
				lat: parseFloat(lat),
				lng: parseFloat(lng)
			},
			map: map,
			icon: $mapElem.data('marker-url')
		});

	map.markers = [];

	map.markers.push(marker);
}